/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


document.addEventListener('DOMContentLoaded', function() {
  /* Add to cart Booster */
  if (document.body.classList.contains('template-product')) {
    $(window).on('scroll', function () {
      $('.Product__FloatingInner').toggleClass(
        'is-floating',
        $(window).scrollTop() > 0 && $(window).width() <= 640
      );
    });
  }

  // Option select
  window.addEventListener('click', (e) => {
    const el = e.target;
    if (el.classList.contains('canadian-select__options__option')) {
      console.log('canadian clicked');
      const selectedHandle = el.dataset.value;
      const selectedValue = el.innerText;
      const container = el.parentElement.parentElement;
      const realSelectedEl = container.querySelector('[selected');
      const displaySelectedEl = container.querySelector(
        '.canadian-select__selected'
      );
      displaySelectedEl.innerHTML = selectedValue;
      realSelectedEl.innerHTML = selectedValue;
      realSelectedEl.setAttribute('value', selectedHandle);
    }
  });

  /* eslint-disable max-len */

    const collapsibles = Array.from(
      document.getElementsByClassName('collapsible')
    );

    collapsibles.forEach((collapsible, i) => {
      collapsible.dataset.collapsedHeight = collapsible.clientHeight;
      collapsible.dataset.openedHeight = collapsible.scrollHeight;
      collapsible.dataset.collapsed = 'true';

      let collapsibleParent = null;

      if (collapsible.parentElement.classList.contains('collapsible')) {
        collapsibleParent = collapsible.parentElement;
      }

      if (
        collapsible.parentElement.parentElement.classList.contains(
          'collapsible'
        )
      ) {
        collapsibleParent = collapsible.parentElement.parentElement;
      }

      collapsible.addEventListener('click', (e) => {
        const isCanadianSelect = e.target.className.includes('canadian-select');
        !isCanadianSelect && e.stopPropagation();

        const clickedCollapse =
          e.target === collapsible
            ? collapsible
            : e.target.closest('.collapsible');

        const isMobile = window.innerWidth < 768;
        if (
          clickedCollapse.classList.contains('collapsible--mobile-only') &&
          !isMobile
        ) {
          return;
        }

        const isClosed = clickedCollapse.dataset.collapsed === 'true';
        const openHeightGreaterThanScrollHeight =
          clickedCollapse.dataset.openedHeight > clickedCollapse.scrollHeight;
        const dataUnset = clickedCollapse.dataset.openedHeight === '0';

        if (dataUnset || (isClosed && openHeightGreaterThanScrollHeight)) {
          clickedCollapse.dataset.collapsedHeight =
            clickedCollapse.clientHeight;
          clickedCollapse.dataset.openedHeight = clickedCollapse.scrollHeight;
        } else {
          clickedCollapse.dataset.openedHeight = clickedCollapse.scrollHeight;
        }

        if (isClosed) {
          clickedCollapse.style.height = `${clickedCollapse.dataset.openedHeight}px`;
          clickedCollapse.dataset.collapsed = 'false';

          if (collapsibleParent) {
            const newcollapsibleParentOpenHeight =
              parseInt(collapsibleParent.dataset.openedHeight, 10) +
              (clickedCollapse.dataset.openedHeight -
                clickedCollapse.dataset.collapsedHeight);
            collapsibleParent.style.height = `${newcollapsibleParentOpenHeight}px`;
            collapsibleParent.dataset.openedHeight = newcollapsibleParentOpenHeight;
          }
        } else {
          clickedCollapse.style.height = `${clickedCollapse.dataset.collapsedHeight}px`;
          clickedCollapse.dataset.collapsed = 'true';

          if (collapsibleParent) {
            const newcollapsibleParentOpenHeight =
              parseInt(collapsibleParent.dataset.openedHeight, 10) -
              (clickedCollapse.dataset.openedHeight -
                clickedCollapse.dataset.collapsedHeight);
            collapsibleParent.style.height = `${newcollapsibleParentOpenHeight}px`;
            collapsibleParent.dataset.openedHeight = newcollapsibleParentOpenHeight;
          }
        }
      });

      if (i === collapsibles.length - 1) {
        const event = new Event('collapsiblesLoaded');
        window.dispatchEvent(event);
      }
    });
})